import Reflux from "reflux";
import { merge } from "lodash";
import Freezer from "freezer-js";
import ReadingChallengeActions from "../react_actions/reading_challenge_actions";

const DEFAULT_STATE = { showLoadingSpinner: false };
const state = new Freezer({});

const getState = function() {
  return state.get();
};

export default Reflux.createStore({
  listenables: ReadingChallengeActions,
  getInitialState: getState,
  getState,

  initializeWith(data) {
    getState().reset(merge({}, DEFAULT_STATE, data));
  },

  updateWith(data) {
    this.initializeWith(data);
  },

  onStartChallenge() {
    this.trigger(getState().set("showLoadingSpinner", true));

    const currentState = getState();
    const data = {
      user_challenge: {
        challenge_id: currentState.readingChallengeId,
        goal: currentState.booksToRead,
      },
      format: "json",
    };

    $j.ajax({
      url: "/user_challenges/create_or_update",
      method: "PUT",
      data,
    }).done((resp) => {
      this.trigger(getState().reset(resp));
    }).fail(() => {
      window.alert("There was an error starting your reading challenge, please try again.");
    }).always(() => {
      this.trigger(getState().set("showLoadingSpinner", false));
    });
  },

  onBookNumChanged(value) {
    if (!isNaN(value)) {
      this.trigger(getState().set("booksToRead", parseInt(value)));
    }
  },

  reset() {
    getState().reset(DEFAULT_STATE);
  },
});
